import { gql } from '@apollo/client';

export const GET_PAYMENT_LINK = gql`
  query personalizedOffer($where: OfferUniqueInput!) {
    personalizedOffer(where: $where) {
      data {
        id
        plan {
          id
        }
        uniqueToken
        link
        actualPrice
        discountPrice
        offerPrice
        expiryDate
        paymentStatus
        status
        isRedeemed
        createdAt
        updatedAt
        notes
        __typename
      }
      message
      __typename
    }
  }
`;

// Query to fetch personalized offers
export const GET_PAYOUT_LINKS = gql`
  query paymentLinks($filter: PaymentLinkFilter, $sort: PaymentLinkSort) {
    paymentLinks(filter: $filter, sort: $sort) {
      count
      data {
        metaData
        actualPrice
        sellingPrice
        id
        user {
          firstName
          lastName
          id
          userNumber
          contactNo
          email
        }
        status
        createdAt
        expiredAt
        creator {
          lastName
          firstName
          userNumber
        }
        paymentLink
        subscriptionPlan {
          name
          slug
          price
          price
          type
          subscriptionFeatures {
            planVersion
          }
        }
      }
    }
  }
`;

// Query to fetch a single personalized offer
export const GET_PERSONALIZED_OFFER = gql`
  query personalizedOffer($where: OfferUniqueInput!) {
    personalizedOffer(where: $where) {
      data {
        id
        plan {
          id
        }
        uniqueToken
        actualPrice
        discountPrice
        offerPrice
        expiryDate
        paymentStatus
        isRedeemed
        createdAt
        updatedAt
      }
      message
    }
  }
`;

export const CREATE_PAYMENT_LINK = gql`
  mutation createPaymentLink($data: CreatePaymentLinkInput!) {
    createPaymentLink(data: $data) {
      data {
        id
      }
    }
  }
`;
